import React from 'react';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {modalClose, modalChange} from '~/modules/modal/actions';
import { sendPhone,verifyPhoneAction ,verifyPhoneActionFromEmail } from '~/modules/verify/actions';
import mapDispatch from '~/misc/mapDispatch';
import * as modes from '~/modules/modal/modes';
import css from './index.css';
import Input from "~/components/pages/MyAccount/share/Input";
import cs from 'classnames'
import Button from '~/components/common/Button';
import {tipsChange} from '~/modules/tips/actions'; 

class ButtonWithCount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 0,
      error: ""
    }
  }
  componentWillUnmount() {
    clearTimeout(this.cleanTime);
  }
  cooldown = () => {
    this.setState({
      time: 60
    })
    this.timer();
  } 
  timer = () => {
    const time = setTimeout(() => {
      const { time } = this.state;
      if (time - 1 > 0) {
        this.timer();
      }else {
        clearTimeout(time);
      }
      this.setState({
        time: this.state.time - 1,
      });
    }, 1000);
    this.cleanTime = time;
  };
  getCode = () => {
    const { getCode } = this.props;
    getCode().then(()=>{
      this.cooldown();
    }).catch(()=>{
      //do nothing
    })
  }

  render() {
    const { time } = this.state;
    const disabled = !!time ;
    return (
      <Button 
        mods={['large']} 
        disabled={disabled} 
        onClick={this.getCode} 
        className={cs(
          css.codeBtnFix,
          {
            [css.codeBtn]: !disabled
          }
        )}>
        { time || "send" }
      </Button>
    )
  }
}

class PhoneValidate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: null,
      code: null,
      isResend: false,
      codeError: null,
      formatError: null,
    }
  }
  handleChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.name]: e.target.value
    })
  } 
  getCode = () => {
    const { phone } = this.state;
    if(!/^[0-9]{10}$/.test(phone)) {
      this.setState({
        formatError: 'Invalid phone number'
      })
      return Promise.reject();
    }else {
      this.setState({
        formatError: ''
      })
      return this.props.sendPhone(phone).then(()=>{
        this.setState({
          isResend: true
        })
      })
    }
  }
  showError = (errorString) => {
    this.setState({
      codeError: errorString
    })
  }
  verify = () => {
    const { phone, code } = this.state;
    const { showSuccess, showErrorTips } = this.props;
    const { showError } = this;
    this.props.verifyPhone({
      phoneNumber: phone,
      code
    }).then(res => {
      const { code } = res;
      switch(code){
        case 200: 
          showSuccess();
        break;
        case 60003: 
          showError("Verification Code incorrect");
      }
      return res;
    })
    .catch(error => {
      showErrorTips();
      throw error;
    })
  }
  render() {
    const {codeError, formatError, isResend} = this.state;
    if (isEmpty(this.props.context)) {
      return null;
    }
    return (
      <div className={css.popwrap}>
        <div className={css.title}>Verify Your Number</div>
        <Input
          mods={["floatLef", "strench"]}
          title={"Phone Number"}
          label={"phone"}
          readOnly={true}
          placeholder={"Enter your phone number"}
          fnChange={this.handleChange}
          type="text"
          error={formatError}
        />
        <div className={css.codeColumn}> 
          <Input
            mods={["floatLef", "strench"]}
            title={"Verification Code"}
            label={"code"}
            readOnly={true}
            placeholder={"Enter 6 digits code"}
            fnChange={this.handleChange}
            error={codeError}
            type="text"
          />
          <ButtonWithCount
            getCode = {this.getCode}
          ></ButtonWithCount>
        </div>
        {
          isResend && 
          <div className={css.resendHint}>Resend code (if you don’t receive your confirmation code in 60s, request for another code)</div>
        }
        <div className={css.buttonColumn}> 
          <Button  mods={['large']} onClick= {this.props.closePop}>Cancel</Button>
          <Button
            mods={['large', 'action']}
            onClick= {this.verify}
          >OK</Button>
        </div>
        
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.PHONE_VALIDATE),
  sendPhone: (props, phoneNumber) =>  sendPhone(phoneNumber),
  verifyPhone: (props, {phoneNumber,code}) => 
    props.context.from === 'email' ? verifyPhoneActionFromEmail(phoneNumber,code) : verifyPhoneAction (phoneNumber,code),
  showSuccess: (props)  => modalChange(modes.PHONE_SUCCESS, {type: 'askPop'}),
  showErrorTips: (props) => tipsChange({type: 'failed', source: 'verify-email'},'Something went wrong please try again. If the problem persists, please contact us.')
}))(PhoneValidate);




// WEBPACK FOOTER //
// ./src/components/Popup/PhoneValidate/index.js